<template>
    <div :class="inputClass">
        <label
            class="input__label"
            v-if="showLabel"
            :class="{ 'required-input': mandatory }"
            for="telephone"
            v-text="label || $t('TELEPHONE_FIELD_PHONE_NUMBER')"/>
        <input
            id="telephone"
            name="email"
            autocomplete="tel"
            type="tel"
            class="input__field"
            v-model.trim="telephone">

        <!-- Validation -->
        <p class="input__message"
           v-if="message"
           v-text="message"/>
        <p class="input__message"
           v-else-if="errorHandler.has('telephone')"
           v-text="errorHandler.get('telephone')"/>
        <p class="input__message"
           v-else-if="null !== telephone && !isTelephoneValid"
           v-html="$t('TELEPHONE_FIELD_SORRY')"/>
    </div>
</template>

<script>
import debounce from 'lodash/debounce';
import { isTelephoneNumberValid, telephoneNumberInternationlFormat } from '@/helpers/TelephoneHelpers';
import ErrorResponseHandler from '@/helpers/ErrorResponseHandler';
import TelephoneService from '@/services/users/TelephoneService';

export default {
    name: 'TelephoneField',
    data() {
        return {
            telephone: null,
            errorHandler: new ErrorResponseHandler(),
        };
    },
    props: {
        value: {
            default: null,
            type: String,
        },
        label: {
            default: null,
            type: String,
        },
        shouldValidate: {
            default: false,
            type: Boolean,
        },
        showLabel: {
            default: true,
            type: Boolean,
        },
        message: {
            required: false,
            type: String,
            default: null,
        },
        isValid: {
            default: true,
            type: Boolean,
        },
        mandatory: {
            default: false,
            type: Boolean,
        },
    },
    methods: {
        /**
         * Handle validating the telephone number.
         *
         * @returns {void}
         */
        validateTelephone() {
            TelephoneService.isTelephoneAvailable(this.telephone)
                .then(() => this.errorHandler.reset())
                .catch(error => this.errorHandler.setResponse(error.response.data));
        },
    },
    computed: {
        isTelephoneValid() {
            return this.value !== null &&
                this.hasValidFormat && this.isValid &&
                !this.errorHandler.has('telephone');
        },
        hasValidFormat() {
            return isTelephoneNumberValid(this.telephone);
        },
        inputClass() {
            if (this.telephone === null && this.isValid === true) {
                return 'input';
            }

            return this.isTelephoneValid ? 'input input--success' : 'input input--invalid';
        },
    },
    watch: {
        telephone: debounce(function(value) {
            this.$emit('input', value);
            this.telephone = this.hasValidFormat ? telephoneNumberInternationlFormat(value) : value;
            this.shouldValidate && this.hasValidFormat ? this.validateTelephone(value) : false;
        }, 1000),
        value: {
            immediate: true,
            handler(value) {
                this.telephone = value;
            },
        },
    },
};
</script>
